import React from 'react'
import P5Wrapper from 'react-p5-wrapper'

const canvasSize = 800
const IMAGE_DIMENSIONS = { width: 1920, height: 1080 } //{ width: 1920, height: 1080 }
const PIXEL_DENSITY = 2
const ASPECT_RATIO = IMAGE_DIMENSIONS.width / IMAGE_DIMENSIONS.height

function sketch(p) {
	p.disableFriendlyErrors = true

	let innerCircles = GraphicCircles.defaultProps.innerCircles
	let leaves = GraphicCircles.defaultProps.leaves
	let shapeSize = GraphicCircles.defaultProps.shapeSize
	let colors = GraphicCircles.defaultProps.colors
	let bg = GraphicCircles.defaultProps.backgroundColor
	let direction = GraphicCircles.defaultProps.direction
	let grain = GraphicCircles.defaultProps.grain
	let lastCanvasWidth = canvasSize
	let lastCanvasHeight = canvasSize
	let canvasWidth = canvasSize
	let canvasHeight = canvasSize
	let shape = GraphicCircles.defaultProps.shape
	let randomizer = GraphicCircles.defaultProps.randomizer

	let pg = null

	p.setup = function () {
		p.pixelDensity(PIXEL_DENSITY)
		p.createCanvas(canvasSize, canvasSize, p.P2D)

		pg = p.createGraphics(
			IMAGE_DIMENSIONS.width,
			IMAGE_DIMENSIONS.height,
			p.P2D
		)

		pg.background(bg)
		p.background(bg)

		p.noLoop()
	}

	p.saveImage = function () {
		pg.save(pg, 'flower-' + new Date().toISOString() + '.png')
	}

	p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
		if (props.innerCircles !== null) {
			innerCircles = props.innerCircles
		}
		if (props.leaves !== null) {
			leaves = props.leaves
		}
		if (props.shapeSize !== null) {
			shapeSize = props.shapeSize
		}
		if (props.colors !== null) {
			colors = props.colors
		}
		if (props.backgroundColor !== null) {
			bg = props.backgroundColor
		}
		if (props.direction !== null) {
			direction = props.direction
		}
		if (props.grain !== null) {
			grain = props.grain
		}
		if (props.shape !== null) {
			shape = props.shape
		}
		if (props.randomizer !== null) {
			randomizer = props.randomizer
		}
		if (props.width !== null || props.height !== null) {
			canvasWidth = props.width
			canvasHeight = props.height
		}
		if (props.export() !== null) {
			if (props.export() === true) {
				p.saveImage()
			}
		}
		p.redraw()
	}

	p.draw = function () {
		if (canvasWidth !== lastCanvasWidth || canvasHeight !== lastCanvasHeight) {
			p.resizeCanvas(canvasWidth, canvasHeight)
			lastCanvasWidth = canvasWidth
			lastCanvasHeight = canvasHeight
		}

		pg.noStroke()
		pg.background(bg)

		const size = (1 / shapeSize) * IMAGE_DIMENSIONS.height

		pg.push()

		const nMax = innerCircles
		const rMax = leaves

		let flower = p.createGraphics(size * 4, size * 4)
		//flower.background(255, 255, 0)

		const drawShape = (parent, x, y, size) => {
			let start
			let tip
			let width
			let form

			switch (shape) {
				case 'randomLeave':
					start = { x: x, y: y + size }
					tip = { x: x, y: y - size * randomizer.tip }
					width = randomizer.width * size
					form = randomizer.form * size

					parent.beginShape()
					parent.vertex(start.x, start.y)
					parent.bezierVertex(x + width, y - form, tip.x, tip.y, tip.x, tip.y)
					parent.bezierVertex(
						tip.x,
						tip.y,
						x - width,
						y - form,
						start.x,
						start.y
					)
					parent.endShape()
					break
				case 'bezierVertex2':
					start = { x: x, y: y + size }
					tip = { x: x, y: y - size * 1.5 }
					width = 2 * size
					form = -2 * size
					parent.beginShape()
					parent.vertex(start.x, start.y)
					parent.bezierVertex(x + width, y - form, tip.x, tip.y, tip.x, tip.y)
					parent.bezierVertex(
						tip.x,
						tip.y,
						x - width,
						y - form,
						start.x,
						start.y
					)
					parent.endShape()
					break
				case 'bezierVertex':
					parent.beginShape()
					parent.vertex(x, y + size)
					parent.bezierVertex(x + size, y, x - size, y, x, y - size * 2)
					parent.vertex(x, y + size)

					parent.endShape()
					break
				case 'bezier':
					parent.beginShape()

					parent.bezier(
						x,
						y + size,
						x + 2 * size,
						y - 2 * size,
						x - 2 * size,
						y - 2 * size,
						x,
						y + size
					)

					parent.endShape()
					break
				case 'vertex':
					parent.beginShape()
					parent.vertex(x, y)
					//parent.bezierVertex(x, y + size, x + 2 * size, y, x + size, y)
					parent.bezierVertex(x, y + size, x + 2.5 * size, y, x + size, y)
					parent.bezierVertex(x, y + size, x, y - 1.5 * size, x - size, y)
					//parent.bezierVertex(x, y - size, x - size, y - size, x + size, y)
					parent.endShape()
					break
				case 'ellipse':
					start = { x: x, y: y - randomizer.start * size }
					tip = { x: x, y: (size * randomizer.tip) / 1.5 }
					width = size / randomizer.width
					form = randomizer.form * size

					parent.ellipseMode(p.RADIUS)
					parent.ellipse(start.x, start.y, width, tip.y)
					break
				case 'star':
					parent.quad(
						x,
						y,
						x - size / 2,
						y + size,
						x + 2 * size,
						y + 2 * size,
						x + size / 2,
						y - size / 2
					)
					break
				case 'triangle':
					start = {
						x: x - (randomizer.form / 6) * size,
						y: y + randomizer.start * size,
					}
					tip = { x: x, y: y - size * randomizer.tip }
					width = (randomizer.width / 2) * size

					parent.triangle(start.x, start.y, tip.x, tip.y, x + width, y)
					break
				case 'square':
					parent.rectMode(p.RADIUS)
					parent.square(x + size, y, size)
					break
				default:
					parent.ellipseMode(p.RADIUS)

					parent[shape](x, y, size)
					break
			}
		}

		for (let r = 1; r <= rMax; r++) {
			let circles = p.createGraphics(size * 4, size * 4)
			let circleMask = p.createGraphics(size * 4, size * 4)
			circles.push()
			//circles.background(255, 0, 0)

			circles.noStroke()
			circles.ellipseMode(p.RADIUS)

			for (let n = 0; n < nMax; n++) {
				const offset = (n / (nMax + 1)) * (size / 2)
				circles.fill(colors[(n + r) % colors.length])

				//circles.circle(size * 2, size * 1.5 + offset, size / 2 - offset)
				drawShape(circles, size * 2, size * 1.5 + offset, size / 2 - offset)
			}

			let shadow = p.lerpColor(p.color(bg), p.color('rgb(0,0,0)'), 0.2)
			shadow.setAlpha(0.3 * 255)

			circles.push()
			circles.blendMode(p.MULTIPLY)
			circles.fill(shadow)

			circles.translate(2 * size, 2 * size)
			circles.point(0, 0)
			circles.rotate(direction * (1 / rMax) * p.PI * 2)
			circles.rotate(direction * (-1 / (rMax * 4)) * p.PI * 2)
			//circles.circle(0, -0.5 * size, size / 2)
			drawShape(circles, 0, -0.5 * size, size / 2)
			circles.rotate(direction * (-1 / (rMax * 4)) * p.PI * 2)
			//circles.circle(0, -0.5 * size, size / 2)
			drawShape(circles, 0, -0.5 * size, size / 2)
			circles.blendMode(p.BLEND)

			circles.pop()

			circleMask.noStroke()
			circleMask.ellipseMode(p.RADIUS)
			circleMask.fill(bg)

			circleMask.translate(2 * size, 2 * size)

			//circleMask.circle(0, -0.5 * size, size / 2)
			drawShape(circleMask, 0, -0.5 * size, size / 2)
			circleMask.blendMode(p.REMOVE)

			circleMask.fill('rgba(255, 0, 0, 1)')

			circleMask.rotate(direction * (1 / rMax) * (Math.PI * 2))

			//circleMask.circle(0, -0.5 * size, size / 2)
			drawShape(circleMask, 0, -0.5 * size, size / 2)
			circles.pop()

			let circleImage = p.createImage(size * 4, size * 4)

			circleImage.copy(
				circles,
				0,
				0,
				circles.width,
				circles.height,
				0,
				0,
				circleImage.width,
				circleImage.height
			)

			circleImage.mask(circleMask)
			flower.push()
			flower.translate(size * 2, size * 2)
			flower.rotate(direction * (r / rMax) * (Math.PI * 2))
			flower.imageMode(flower.CENTER)
			flower.image(circleImage, 0, 0)

			flower.pop()
		}

		pg.imageMode(p.CENTER)
		pg.image(flower, pg.width / 2, pg.height / 2.33)

		pg.pop()

		const addGrain = (res = 1, dist = 1, size = 96, strength = 0.2) => {
			const grainTileSize = (res + dist) * size
			let grain = p.createGraphics(grainTileSize, grainTileSize)

			for (let pX = 0; pX < grainTileSize; pX += res + dist) {
				for (let pY = 0; pY < grainTileSize; pY += res + dist) {
					let color = p.color(
						p.noise(pX + p.random(0, 10), pY + p.random(0, 10)) * 255,
						strength * 255
					)
					let weight =
						res +
						p.noise(pX + p.random(0, 10) * 10, pY + p.random(0, 10)) * dist

					// grain.fill(color)
					// grain.noStroke()

					grain.stroke(color)
					grain.strokeWeight(weight)
					grain.point(
						pX + weight / 2 + p.random(0, dist),
						pY + weight / 2 + p.random(0, dist)
					)
					//grain.rect(pX, pY, res, res)
				}
			}
			pg.blendMode(p.OVERLAY)
			for (let iX = 0; iX < IMAGE_DIMENSIONS.width; iX += grainTileSize) {
				for (let iY = 0; iY < IMAGE_DIMENSIONS.height; iY += grainTileSize) {
					pg.image(
						grain,
						iX,
						iY,
						grainTileSize,
						grainTileSize,
						0,
						0,
						grainTileSize,
						grainTileSize
					)
				}
			}

			pg.blendMode(p.BLEND)
		}

		if (grain) addGrain(0.25, 0.75, 256, 0.4)

		p.imageMode(p.CENTER)

		if (canvasWidth / canvasHeight > ASPECT_RATIO) {
			// Landscape
			//zoomFactor = canvasWidth > 2 * canvasHeight ? 1.5 : 1

			p.image(
				pg,
				canvasWidth / 2,
				canvasHeight / 2,
				canvasWidth,
				canvasWidth / ASPECT_RATIO,
				0,
				0,
				IMAGE_DIMENSIONS.width,
				IMAGE_DIMENSIONS.height
			)
		} else {
			// Portrait
			//zoomFactor = canvasWidth > canvasHeight ? 1.25 : 1.5
			p.image(
				pg,
				canvasWidth / 2,
				canvasHeight / 2,
				canvasHeight * ASPECT_RATIO,
				canvasHeight,
				0,
				0,
				IMAGE_DIMENSIONS.width,
				IMAGE_DIMENSIONS.height
			)
		}
	}
}

export default function GraphicCircles(props) {
	return <P5Wrapper sketch={sketch} {...props} />
}

GraphicCircles.defaultProps = {
	width: canvasSize,
	height: canvasSize,
	innerCircles: 5,
	leaves: 5,
	shapeSize: 20,
	colors: ['#FFFFFF', '#C800FF', '#0015D6', '#FF005D', '#43C9CB'],
	backgroundColor: '#000000',
	direction: 1,
	grain: true,
	shape: 'circle',
	randomizer: { tip: 1.5, width: 2, form: 1 },
	export: () => false,
}
